module.exports = __webpack_public_path__ + "static/img/戴防毒面具.2d8dddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/戴防毒面具.png
// module id = IzMH
// module chunks = 1